@if (downloadItem; as item) {
  @if (item.displayButton === 'true') {
    <div class="download-item-container {{ styleClasses ? styleClasses : ''}}">
      <div class="download-item-image {{ styleClasses ? styleClasses : ''}}">
        <cx-media [container]="item.thumbnail ? item.thumbnail : defaultThumbnail" [alt]="item.name?item.name:''" [title]="item.name?item.name:''" ></cx-media>
      </div>
      @if (item.name) {
        <div class="download-item-text-wrapper">
          <div  class="download-item-title text-left-aligned">
            {{ item.name }}
          </div>
          @if (item.subtitle) {
            <div class="download-item-subtitle text-left-aligned">
              {{ item.subtitle }}
            </div>
          }
        </div>
      }
      <div class="download-item-link">
        <app-download-link
          [url]="item.downloadFile.url"
          [target]="item.downloadFile.openFirst==='true' ? '_blank' : '_self'"
          [classes]="['btn btn-block btn-primary']"
          >
          @if (item.downloadFile.openFirst==='true') {
            {{ item.buttonText ? item.buttonText : 'tooltip.view' | cxTranslate }}
          } @else {
            {{ item.buttonText ? item.buttonText : 'tooltip.download' | cxTranslate }}
          }
        </app-download-link>
      </div>
    </div>
  } @else {
    <div class="download-item-container">
      <a [href]="item.downloadFile.url" [target]="item.downloadFile.openFirst==='true' ? '_blank' : '_self'">
        <div class="download-item-box {{ styleClasses ? styleClasses : ''}}">
          <div class="download-item-image">
            <cx-media [container]="item.thumbnail ? item.thumbnail : defaultThumbnail" [alt]="item.name?item.name:''" [title]="item.name?item.name:''" ></cx-media>
          </div>
          @if (item.name) {
            <div class="download-item-text-wrapper">
              <div  class="download-item-title">
                {{ item.name }}
              </div>
              @if (item.subtitle) {
                <div class="download-item-brand">
                  {{ item.subtitle }}
                </div>
              }
            </div>
          }
        </div>
      </a>
    </div>
  }
}

